<template>
  <div>
    <vue-headful
        :title="$t('pages.work') + ' - Fernando Mata'"
      />
      <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
      <div id="experiencesContainer" v-for="experience in experiences" :key="experience.name">
        <article class="post">
          <CompanyCard :experience="experience" @gallery="openGallery" />
        </article>
      </div>
  </div>
</template>

<script>
import CompanyCard from '../components/CompanyCard.vue'
import { Trans } from '../localization/Translation.js'
import Experiences from '../data/Experience.json'
import VueGallerySlideshow from 'vue-gallery-slideshow'

export default {
  data() {
    return {
      images: [],
      index: null
    }
  },
  computed: {
    experiences() {
      return Experiences[Trans.currentLanguage].sort(function (a,b) {
      Date(a.joinedAt) < Date(b.joinedAt)
      })
    }
  },
  methods: {
    openGallery(images) {
      this.images = images.map(a => "/companies/" + a)
      this.index = 0
    },
    clear() {
      this.images = []
      this.index = null
    }
  },
  name: "Experience",
  components: {
    CompanyCard,
    VueGallerySlideshow
  }
}
</script>

<style scoped>
.post {
  padding: 1em 3em 1em 3em;
}
.vgs {
  z-index: 10001;
}
.vgs >>> button {
  border: none;
  padding: 0;
  line-height: 0;
  letter-spacing: 0;
  box-shadow: none;
  color: #d9d9d9 !important;
}
</style>
